import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';
import { Modal } from '../../components';
import classNames from 'classnames';
import css from './MetaMapVerificationModal.module.css';
import { pathByRouteName } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { FormattedMessage, useIntl } from 'react-intl';
import { metaMapKeys } from '../../util/enums';
import { getVerificationDetails } from '../../util/genericHelpers';

const MISSING_INFORMATION_MODAL_WHITELIST = [
  'LoginPage',
  'SignupPage',
  'ContactDetailsPage',
  'EmailVerificationPage',
  'PasswordResetPage',
  'StripePayoutPage',
];

function MetaMapVerificationModal(props) {
  const { flowId, currentUser, onManageDisableScrolling ,isVerifyModal,setIsVerifyModal } = props;
  const button = useRef(null);
  const dispatch = useDispatch();
  const [loaded, setLoaded] = useState(false);
  const routeConfiguration = useRouteConfiguration();
  const routes = routeConfiguration;
  const intl = useIntl();
  const whitelistedPaths = MISSING_INFORMATION_MODAL_WHITELIST.map(page =>
    pathByRouteName(page, routes)
  );
  const {identityId} = getVerificationDetails(currentUser);

  // // Open modal if identityId doesn't exist
  // useEffect(() => {
  //   const currentPath = location.pathname;

  //   // Only open the modal if identityId is missing AND the user is NOT on a whitelisted path
  //   if (!identityId && !whitelistedPaths.includes(currentPath)) {
  //     setIsVerifyModal(true);
  //   }
  // }, [identityId, location.pathname]);

  useEffect(() => {
    if (!document.querySelector('script[src="https://web-button.metamap.com/button.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://web-button.metamap.com/button.js';
      script.async = true;
      script.onload = () => setLoaded(true);
      document.body.appendChild(script);
    } else {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (loaded && button.current) {
      button.current.addEventListener('metamap:loaded', ({ detail }) =>
        console.log('[METAMAP] Loaded', detail)
      );
      button.current.addEventListener('metamap:userStartedSdk', ({ detail }) =>
        dispatch(updateProfile({ publicData: { verificationDetail: detail } }))
      );
      button.current.addEventListener('metamap:userFinishedSdk', ({ detail }) => {
        console.log('[METAMAP] User finished verification', detail);
        setIsVerifyModal(false); // Close modal after verification
      });
      button.current.addEventListener('metamap:exitedSdk', ({ detail }) => {
        console.log('[METAMAP] User exited verification', detail);
        setIsVerifyModal(false);
      });
    }
  }, [loaded]);

  const classes = classNames(css.root);

  return (
    <Modal
      id="MetaMapVerificationModal"
      className={classes}
      isOpen={isVerifyModal}
      onClose={() => setIsVerifyModal(false)}
      closeButtonMessage={intl.formatMessage({
        id: 'MetaMapVerificationModal.close',
      })}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <div className={css.modalContent}>
        <h2>
          <FormattedMessage id="MetaMapVerificationModal.verifyText" />
        </h2>
        <p>
          <FormattedMessage id="MetaMapVerificationModal.verifyDescription" />
        </p>
        <div className={css.metamapSec}>
          {loaded ? (
            <metamap-button
              ref={button}
              clientid={metaMapKeys.matiClientId}
              flowId={"681e6205384d7f553fd7b081"}
              identityId={identityId}
              metadata={JSON.stringify({ userId: currentUser?.id?.uuid })}
              language="en"
              fixedLanguage="en"
              color="orange"
            />
          ) : (
            <p>
              <FormattedMessage id="MetaMapVerificationModal.Loading" />
            </p>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default MetaMapVerificationModal;
